import Vue from "vue";
import VCharts from "v-charts";
import Echarts from "echarts";

import Base from "cnetong-core-frontend";
import "cnetong-core-frontend/lib/index.css";
import ElementUI from "element-ui";
import tabs from "./tabs";
import config from "./config";
import init from "@/init";
import stores from "./store";

import Login from '@/module/layout/login/Login.vue';

Vue.use(VCharts);
Vue.prototype.$echarts = Echarts;

ElementUI.FormItem.props.showMessage.default = true;

// npm --registry=https://registry.npm.taobao.org install
export default Base.bootstrap({
    init,
    tabs,
    stores,
    config,
    el: "#app",
    routes: [{path: "/login", component: Login}],
});